import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { decorators } from "@orange-marmalade/paginate-this";
import _, { without } from "lodash";
import * as actions from "MODULES/companies/actions";
import Delete from "MODULES/shared/components/Delete";
import { Authorized, DataTable } from "MODULES/shared/components";
import {
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES,
  ROLES,
  WAREHOUSE
} from "MODULES/users/constants";
import { CARRIERS } from "MODULES/shared/constants";
import NewShippingMethod from "./Create/NewShippingMethod";
import EditShippingMethod from "./Edit/EditShippingMethods";

class ShippingMethods extends React.Component {
  state = {
    editShippingMethodModalOpen: false,
    deleteOpen: false,
    selectedMethod: Map()
  };

  shippingMethods = (carrier, method) =>
    _.get(CARRIERS[carrier], `shippingMethods.${method}.label`);

  carrier = carrier => _.get(CARRIERS[carrier], ["label"]);

  openShippingMethodsModal = pref =>
    this.setState({
      editShippingMethodModalOpen: true,
      selectedMethod: pref
    });

  closeShippingMethodsModal = () =>
    this.setState({ editShippingMethodModalOpen: false });

  renderRow = row => {
    const carrier = row.carrier;
    const method = row.shipping_method;

    return (
      <tr
        key={row.id}
        className="clickable"
        onClick={() => this.openShippingMethodsModal(row)}
      >
        <td>{this.carrier(row.carrier)}</td>
        <td>{this.shippingMethods(carrier, method)}</td>
        <td>{row.account_number}</td>
        <Delete
          primary={false}
          id={row.id}
          deleteAction={actions.destroyShippingMethod}
        />
      </tr>
    );
  };

  render() {
    const { results, isLoading } = this.props;
    const { editShippingMethodModalOpen, selectedMethod } = this.state;

    return (
      <div>
        <h2>
          Shipping Preferences
          <Authorized
            roles={without(ROLES, WAREHOUSE)}
            permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
          >
            <NewShippingMethod />
          </Authorized>
        </h2>

        <DataTable.Mini loading={isLoading}>
          <DataTable.Head>
            <th>Carrier</th>
            <th>Method</th>
            <th>Account #</th>
            <th />
          </DataTable.Head>
          <DataTable.Body>
            {results.map(row => this.renderRow(row))}
          </DataTable.Body>
        </DataTable.Mini>
        <Authorized
          roles={without(ROLES, WAREHOUSE)}
          permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
        >
          <EditShippingMethod
            open={editShippingMethodModalOpen}
            close={this.closeShippingMethodsModal}
            shippingMethod={selectedMethod}
          />
        </Authorized>
      </div>
    );
  }
}

ShippingMethods.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      method: PropTypes.string,
      carrier: PropTypes.string,
      account_number: PropTypes.string
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired
};

export const TabulateAttachments = decorators.tabulate(ShippingMethods);
export default () => <TabulateAttachments listId="company/shippingMethods" />;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/ShippingMethods/ShippingMethods.jsx